import API from "../../Data/Domain/API";
import URL from "../../Data/Domain/URL";
import { getScriptOffsetByUser } from "../../ScriptOffsets/Infrastructure/ScriptOffsets.service";

export async function uploadFile(userId, file) {
  const formData = new FormData();
  formData.append("file", file);

  try {
    await new API(URL.buildUrl(`users/${userId}/scriptOffsets`)).post(
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );

    const scriptOffsets = await getScriptOffsetByUser(userId);
    return scriptOffsets;
  } catch (error) {
    throw new Error(error.error_data.errors);
  }
}
